import { type IApiManager } from '@source-digital/sd-app-core'
import { type RootMessenger } from './root'

export class DefaultApiManager implements IApiManager {
  rootMessenger: RootMessenger
  constructor (rootMessenger: RootMessenger) {
    this.rootMessenger = rootMessenger
  }

  register (name: string, apiDefinition: unknown): void {
    this.rootMessenger.registerApi(name, apiDefinition)
  }

  unregister (name: string): void {
    this.rootMessenger.unregisterApi(name)
  }

  async get<API> (name: string): Promise<API> {
    return await Promise.resolve(this.rootMessenger.getApi(name))
  }
}
